<div class="preloader" *ngIf="isLoading">
    <div class="video-bg"></div>
    <div class="loader-center">
        <img src="assets/siteImg/Gambaji.svg" class="logo-loader" />
    </div>
</div>


<div class="preloader" [class.position]="isGameLaunch" *ngIf="isGameLaunch">
    <div class="video-bg"></div>
    <div class="loader-center">
        <img src="../../../assets/siteImg/Gambaji.svg" class="logo-loader" />
    </div>
</div>